'use client';

import React from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ServiceCardsSection } from '@/features/client/ServiceCardsSection/ServiceCardsSection';
import { ContentLayout } from '@/features/client/Services/components/ContentLayout/ContentLayout';
import { RequestForm } from '@/features/client/Forms/RequestForm/RequestForm';
import { ServicesNavMenu } from '@/features/client/Services/components/ServicesNavMenu/ServicesNavMenu';
import { Content } from '@/features/client/Services/components/Content/Content';
import image from '@/public/images/services/main_page/real_estate_brokerage.webp';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
const data = {
  title: 'Real Estate Expertise',
  description: `At Tytum, we're dedicated to innovation and your home comfort. We aim to keep you comfortable year-round with energy-efficient and built to last solutions.\n\nWith years of experience in the industry, we offer a full spectrum of real estate services tailored to meet your needs. Our dedicated team is here to guide you through buying, selling, renting, and more, ensuring you get the best value and support every step of the way.`,
  image: image,
  offer_title: 'Real Estate Brokerage Services We Offer:',
  offer_data: [
    {
      title: 'Residential Real Estate Services:  ',
      list: [
        { title: '    Home Buying Assistance' },
        { title: 'Home Selling Services' },
        { title: 'First-Time Homebuyer Guidance' },
        { title: 'Luxury Home Sales' },
        { title: 'Comparative Market Analysis (CMA)' },
        { title: 'Property Listings and Marketing' },
        { title: 'Open House Coordination' },
        { title: 'Virtual Tours and 3D Home Showings' },
      ],
    },
    {
      title: 'Real Estate Consultation:  ',
      list: [
        { title: '    Market Trends and Analysis' },
        { title: 'Investment Property Consultation' },
        { title: 'Real Estate Portfolio Management' },
        { title: 'Property Valuation Services' },
        { title: 'Buyer and Seller Representation' },
      ],
    },

    {
      title: 'Commercial Real Estate Services:   ',
      list: [
        { title: '    Office Space Leasing and Sales' },
        { title: 'Retail Space Leasing and Sales' },
        { title: 'Industrial Property Transactions' },
        { title: 'Commercial Property Valuation' },
        { title: 'Investment Property Sales and Acquisitions' },
        { title: 'Commercial Property Management' },
      ],
    },

    {
      title: 'Real Estate Marketing:   ',
      list: [
        { title: '    Professional Photography and Videography' },
        { title: 'Drone Photography and Aerial Views' },
        { title: 'Social Media Marketing for Real Estate' },
        { title: 'Custom Property Websites' },
        { title: 'Print and Digital Advertising' },
        { title: 'Email Marketing Campaigns' },
      ],
    },

    {
      title: 'Home Staging and Preparation:',
      list: [
        { title: '    Professional Home Staging' },
        { title: 'Decluttering and Depersonalization Services' },
        { title: 'Minor Renovations and Repairs' },
        { title: 'Interior Design Consultation' },
        { title: 'Curb Appeal Enhancement' },
      ],
    },

    {
      title: 'Real Estate Investment Services:   ',
      list: [
        { title: '    Rental Property Acquisition' },
        { title: 'Flipping Properties for Profit' },
        { title: 'Real Estate Syndication' },
        { title: 'Short-Term Rental Investment (Airbnb, VRBO)' },
        { title: '1031 Exchange Services' },
      ],
    },
  ],
  banner_title: `“Your Trusted Partner in Real Estate”`,
  banner_description:
    'Navigate the market with confidence with Tytum’s real estate brokerage services. We offer expert guidance and personalized service to help you find your perfect home or investment.',
  bookServiceButton: true,
  why_title: 'Why Choose Tytum for Real Estate Solutions?',

  why_description:
    'We know how crucial it is to promptly and effectively address problems to ensure the safety and functionality of your home. We deliver quality results on time and within budget, turning your dream home into a reality.',
  why_items: [
    {
      title: 'Local Expertise: ',
      description:
        'Our deep knowledge of the local market ensures you get the best value whether buying or selling.',
    },
    {
      title: 'Comprehensive Services: ',
      description:
        'We handle every aspect of the real estate process, making it stress-free and efficient for our clients.',
    },
    {
      title: 'Personalized Approach: ',
      description:
        'We tailor our services to meet your unique needs, ensuring a smooth and successful real estate transaction.',
    },
    {
      title: 'Proven Results: ',
      description:
        'With a track record of successful deals, we’re committed to helping you achieve your real estate goals.',
    },
  ],
  why_footerText:
    'Trust us to be your go-to provider in the San Diego area and ensure the comfort and safety of your home. We also collaborate closely with our team handling <a href="https://tytum.com/services/construction">new construction services</a>, giving clients the option to buy, sell, or even build their dream property from the ground up. Call us or fill out our online form for questions or a free quote.',
};

const RealEstateBrokeragePage = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="arrows">
        <MainSection
          label="Service Details"
          title="Real Estate Brokerage"
          description="Discover your ideal property with our expert real estate services. Whether you’re buying, selling, or renting, we provide comprehensive support to make your real estate journey smooth and successful."
          withContactButton
        />
      </MainSectionLayout>

      <Section variant="secondary">
        <Container>
          <ContentLayout
            contentLeft={
              <>
                <ServicesNavMenu />
                <RequestForm />
              </>
            }
            contentRight={<Content data={data} />}
          />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ServiceCardsSection shortVariant={true} />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ContactUsBanner phone="+1(619) 818-9522" />
        </Container>
      </Section>
    </div>
  );
};

export default RealEstateBrokeragePage;
